import { format } from "date-fns";
import { TblDecInvProyectoSolicitudCronograma } from "./TblProyectoSolicitudCronograma";
import { InitialSolicitudProyectoCabDTO, SolicitudProyectoCabDTO, setSolicitudProyectoCabDTO } from "./SolicitudCab";

export interface ProyectoSolicitudDTO 
{ 
    cabecera: SolicitudProyectoCabDTO,
    cronograma: Array<TblDecInvProyectoSolicitudCronograma>,
}

export function InitialProyectoSolicitudDTO(): ProyectoSolicitudDTO {
    return {
        cabecera: InitialSolicitudProyectoCabDTO(),
        cronograma: []
    }
}

export function setProyectoSolicitudDTO(data: any): ProyectoSolicitudDTO {
    return {
        cabecera: setSolicitudProyectoCabDTO(data.solicitud)??InitialSolicitudProyectoCabDTO(),
        cronograma: data.cronograma??[],
    }
}